import React from 'react';
import Modal from './Modal'; 
import BankTransferInfo from './BankTransferInfo';

/**
 * 口座振替情報表示モーダルコンポーネント（修正版）
 * BankTransferInfoコンポーネントを再利用
 */
const BankTransferInfoModal = ({ 
  isOpen, 
  onClose,
  storeName = null  // 店舗名を受け取る
}) => {
  return (
    <Modal 
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false} // カスタムの閉じるボタンを使用するため無効化
      closeOnBackdropClick={true}
      closeOnEscape={true}
    >
      <div style={{ 
        padding: 20,
        margin: '-20px',
        overflow: 'hidden',
        borderRadius: '8px'
      }}>
        {/* BankTransferInfoコンポーネントを使用 */}
        <BankTransferInfo 
          showTitle={true}
          storeName={storeName}  // 店舗名を渡す
          showAmount={true}      // 金額表示を有効化
          containerStyle={{
            boxShadow: 'none', // Modalコンポーネントが既にシャドウを持っているため
            marginBottom: 0,
            borderRadius: '8px 8px 0 0',
            overflow: 'hidden'
          }}
        />
        
        {/* カスタム閉じるボタン */}
        <button 
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '0 0 8px 8px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: '100%',
            marginTop: '0',
            transition: 'background-color 0.2s ease'
          }}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#0056b3';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#007bff';
          }}
        >
          閉じる
        </button>
      </div>
    </Modal>
  );
};

export default BankTransferInfoModal;